import { range } from 'lodash';

import { NonPerformanceCodeForReportingCycle } from '@willow/graphql-iso/src/app';
import { GqlNonPerformanceCodeToNonPerformanceCode } from '@willow/shared-iso';
import { fnmaCodePriorities } from '@willow/types-iso';

export const getHighestPriorityNonPerformanceCode = (allEvents: NonPerformanceCodeForReportingCycle['events']) => {
  for (const priority of range(1, 7)) {
    const codes = fnmaCodePriorities.get(priority);
    if (!codes) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const events = allEvents?.filter((event) => codes.has(GqlNonPerformanceCodeToNonPerformanceCode[event.code]));
    if (events?.length) {
      return events;
    }
  }
  return [];
};
